/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ThemeEnum {
    Dark = 'dark',
    Light = 'light'
}

export function ThemeEnumFromJSON(json: any): ThemeEnum {
    return ThemeEnumFromJSONTyped(json, false);
}

export function ThemeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThemeEnum {
    return json as ThemeEnum;
}

export function ThemeEnumToJSON(value?: ThemeEnum | null): any {
    return value as any;
}

